export enum SortValues {
  TRENDING = 'trending',
  MOST_RECENT = 'mostRecent',
  CONTENT_TYPE = 'contentType',
}
